import {
  SET_HOST,
  RECEIVE_FINAL_STEPS,
  REQ_FINAL_STEPS,
  RECEIVE_FINAL_STEPS_ERROR,
  SET_PAY_WEEKLY
} from '../actions'

const initialState = {
  host: 'default',
  isError: false,
  payWeekly: false,
  isLoading: false,
  finalSteps:[]
}

export const sign = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAY_WEEKLY:
      return {
        ...state,
        payWeekly: action.data
      }
    case REQ_FINAL_STEPS:
      return {
        ...state,
        isLoading: true
      }
    case RECEIVE_FINAL_STEPS:
      return {
        ...state,
        finalSteps: action.data,
        isLoading: false,
        isError: false
      }
    case RECEIVE_FINAL_STEPS_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true
      }
    case SET_HOST:
      return {
        ...state,
        host: action.host
      }
    default:
      return state
  }
}




// WEBPACK FOOTER //
// /var/www/build-lk-1/src/reducers/signup.js